<div class="ui-messages">
  <p class="ion-text-center">
    Próximamente podrás consultar la ayuda sobre cómo interactuar con las aplicaciones de OkCargo.
  </p>
  <p class="ion-text-center">Coming soon, you have here help about how to interact with OkCargo apps.</p>
</div>
